import { render, staticRenderFns } from "./WrkCtrTable.vue?vue&type=template&id=71f6551e"
import script from "./WrkCtrTable.vue?vue&type=script&lang=js"
export * from "./WrkCtrTable.vue?vue&type=script&lang=js"
import style0 from "./WrkCtrTable.vue?vue&type=style&index=0&id=71f6551e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports